/**
 * @file 监控工具函数
 * @description
 * - MonitorJS 主要初始化逻辑已迁移至 HTML 模板 (views/index-rsbuild.html)
 * - 本文件提供运行时辅助功能：setMonitorUser、initWxObs
 * - 导入此文件会自动执行 initWxObs() 初始化微信会话观测
 */

/**
 * @description 初始化六翼监控 SDK（空实现）
 * MonitorJS 已在 HTML 模板中初始化，此函数仅用于兼容旧代码
 *
 * @deprecated 该函数已废弃，MonitorJS 在 HTML 模板中初始化
 */
export function initSeraphMonitorSDK() {
  // MonitorJS 已在 views/index-rsbuild.html 中通过 <script> 标签初始化
  // 此函数保留用于向后兼容，避免子包中的调用报错
  console.info('[Monitor] MonitorJS 已在 HTML 模板中初始化，无需重复初始化');
}

/**
 * @description 设置六翼监控的用户信息
 * 用于在用户登录后关联用户 ID 与监控数据
 *
 * @param userId - 用户 ID
 */
export function setMonitorUser(userId: string) {
  if (typeof window !== 'undefined') {
    (window as any)?.__SERAPH_HAS_MONITOR__?.setUser?.({ userId });
  }
}

/**
 * @description 初始化微信会话观测（WxObs）SDK
 * 用于在微信环境下采集用户行为和性能数据
 *
 * 功能特性：
 * - 支持 ESModule 和 ES5 两种模式
 * - 可配置隐私脱敏模式
 * - 采集 console 日志和网络请求
 *
 * 参考文档：https://developers.weixin.qq.com/miniprogram/analysis/experience/sdk/
 */
export function initWxObs() {
  // --- 可自定义采集参数 ---
  const param = {
    maskMode: 'no-mask', // all-mask 或 no-mask, 详见：https://developers.weixin.qq.com/miniprogram/analysis/experience/sdk/privacy.html
    recordCanvas: false,  // 若要采集canvas, 设为true
    projectId: 'wxc7d66f0f80d04243-efNdh7oOk-cYC.ya', // 项目 ID
    iframe: false, // 是否采集 iframe 页面
    console: true, // 是否采集 console 输出的错误日志
    network: (info: any) => true, // 是否采集网络错误
  };

  const supportESModule = 'noModule' in document.createElement('script');
  const SCRIPT_URLs = [
    supportESModule
      ? 'https://dev.weixin.qq.com/platform-console/proxy/assets/tel/px.min.js'
      : 'https://dev.weixin.qq.com/platform-console/proxy/assets/tel/px.es5.min.js',
  ];

  function loadScript(url: string) {
    return new Promise((resolve, reject) => {
      const scriptEle = document.createElement('script');
      scriptEle.type = 'text/javascript';
      scriptEle.async = true;
      scriptEle.src = url;
      scriptEle.onload = () => resolve(url);
      scriptEle.onerror = () => reject(new Error('Script load error'));
      document.head.appendChild(scriptEle);
    });
  }

  async function main() {
    try {
      sessionStorage.setItem('wxobs_start_timestamp', String(Date.now()));
      const fastestUrl = await Promise.race(SCRIPT_URLs.map((url) => loadScript(url)));
      (window as any).__startPX && (window as any).__startPX(param);
    } catch (error) {
      console.error('Error loading WxObs scripts:', error);
    }
  }

  main();
}

// 自动初始化微信会话观测
initWxObs();
